// extracted by css-extract-rspack-plugin
export default {"cls1":"TopBar-cls1_HO2","cls2":"TopBar-cls2_rOt TopBar-cls1_HO2"};